import { RecordRTCPromisesHandler, StereoAudioRecorder } from "recordrtc"

export const useRecorderPermission = (recordingType: string) => {
    const initializeRecoder = () => {
        return getPermissionInitializeRecorder()
    }
    const getPermissionInitializeRecorder = async () => {
        const stream = await navigator.mediaDevices.getUserMedia({
            video: false,
            audio: true,
        })

        const recorder = new RecordRTCPromisesHandler(stream, {
            type: recordingType as any,
            recorderType: StereoAudioRecorder,
            numberOfAudioChannels: 1,
        })
        return recorder
    }
    return initializeRecoder
}
